// TODO: Move this to "toolbox"
import { includes } from 'lodash'

const EMPTY_FORMAT = [undefined, null, '', '0001-01-01', '0001-01-01T00:00:00Z']
export default (input) => {
  return !includes(EMPTY_FORMAT, input)
}
